
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"21","viewBox":"0 0 20 21","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.05 16.655a8.03 8.03 0 004.934-1.695l5.32 5.32a1 1 0 001.415-1.414l-5.32-5.32a8.045 8.045 0 10-6.35 3.109zM3.773 4.335a6.046 6.046 0 110 8.551 6.024 6.024 0 010-8.55z","fill":"#E2E8F0"}})])
          )
        }
      }
    